import React, { useState, useEffect, useMemo, useContext } from 'react';
// import Lottie from 'lottie-react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
// import loadingSpinner from '/src/assets/loading_spinner.json';
import greenDot from '/src/assets/Green-Dot-4.svg';
import { WindowSizeContext } from '/src/App';
import './style.css';

const TabCard = ({ tab, activeTab, handleTabChange, onWhatIsQuoll = false }) => {

    const { deviceType } = useContext(WindowSizeContext);

    const [isHovered, setIsHovered] = useState(false);


    const handleMouseEnter = () => {
        setIsHovered(true);
    }

    const handleMouseLeave = () => {
        setIsHovered(false);
    }

    const isActive = activeTab === tab.id || isHovered;

    const iconUrl = tab.icon_svg ? CreateCloudfrontUrl(tab.icon_svg) : tab.icon_dark;

    return (

        <button
            className={`
                    property-explorer-desktop-tab-card
                    ${deviceType}
                    ${isActive ? 'active' : ''
                }`}
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {/* <div className={`property-explorer-desktop-tab-card-background-shape ${isActive ? 'active' : 'inactive'}`}>
                <img 
                    src={greenDot} 
                    className="property-explorer-desktop-tab-card-icon"
                    
                />
            </div> */}
            <div className="property-explorer-desktop-tab-card-icon-container">
                <img
                    src={iconUrl}
                    alt=""
                    className={`property-explorer-desktop-tab-card-icon ${isActive ? 'active' : 'inactive'}`}
                />
            </div>
            <span className="text-align-center property-explorer-desktop-tab-card-name">{tab.name}</span>
        </button>
    )
}

export default TabCard;